import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.meine-erstellten-incidents';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsMeineErstelltenIncidentsEffects {

    MeineErstelltenIncidents$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_MEINE_ERSTELLTEN_INCIDENTS),
        mergeMap((x: ac.GetMeineErstelltenIncidentsAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getMeineErstelltenIncidents(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetMeineErstelltenIncidentsErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetMeineErstelltenIncidentsFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsQueryService);
        }
        return this.service;
    }
}
